import { convert } from 'html-to-text';

// The tags rich text written in the app or by an agent can carry. Matching a
// known tag rather than any angle bracket keeps plain text that happens to read
// "<urgent>" plain, and the name has to end on whitespace, a slash or the
// closing bracket: on a word boundary, the address in
// "Paolo Rossi <p.rossi@acme.it>" reads as a <p>.
const FORMATTING_TAG =
  /<\/?(?:p|br|b|strong|i|em|u|s|ul|ol|li|h[1-6]|blockquote|pre|div|span|a|table|tbody|tr|td|th)(?=[\s/>])[^>]*>/i;

/**
 * Whether the text carries a formatting tag anywhere in it.
 */
export const hasFormattingTag = (text: string): boolean =>
  FORMATTING_TAG.test(text);

/**
 * One-line plain text for an email preview. Images are dropped and links keep
 * only their text: html-to-text otherwise prints them as "[src]" and
 * "text [href]", so a tracking pixel at the top of an email becomes the whole
 * preview.
 */
export const emailPreviewText = (html: string): string =>
  convert(html, {
    selectors: [
      { selector: 'img', format: 'skip' },
      { selector: 'a', options: { ignoreHref: true } },
    ],
    wordwrap: null,
  });
